import React, { FC } from 'react';
import { Link } from 'gatsby';
import { Options } from '@contentful/rich-text-react-renderer';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { INLINES, Hyperlink } from '@contentful/rich-text-types';

import Layout, { Head } from 'components/Layout';

import EntitledSection from 'components/EntitledSection';
import ErrorPage from 'components/ErrorPage';

import {
  IAllContentfulLegalPage,
  IContentfulLegalPageAnchorReference,
} from 'types';

export interface ILegalPageProps {
  data: {
    legalPageData: IAllContentfulLegalPage;
  };
}

/* eslint-disable react/no-danger */
const LegalPage: FC<ILegalPageProps> = ({
  data,
}) => {
  if (!data.legalPageData?.nodes?.length) {
    return <ErrorPage code="404" />;
  }

  const { title, body } = data.legalPageData.nodes[0];

  const options: Options = {
    renderNode: {
      [INLINES.EMBEDDED_ENTRY]: (node) => {
        const { anchor } = node.data.target as IContentfulLegalPageAnchorReference;
        if (!anchor) return null;
        return (
          <span id={anchor} />
        );
      },
      [INLINES.HYPERLINK]: (node) => {
        const { data: hyperlinkData, content } = node as Hyperlink;
        if (!hyperlinkData && !content) return null;
        // TODO: could do it the other way?
        if (hyperlinkData.uri.split('')[0] === '/') {
          return (<Link to={hyperlinkData.uri}>{content[0].value}</Link>);
        }
        return (
          <a href={hyperlinkData.uri}>{content[0].value}</a>
        );
      },
    },
  };

  return (
    <Layout>
      <Head title={title} />

      <EntitledSection title={title}>
        <div>
          {renderRichText(body, options)}
        </div>
      </EntitledSection>
    </Layout>
  );
};
/* eslint-enable react/no-danger */

export default LegalPage;
